module.exports = "../images/fishing-lodge-09.jpg?v=b86b05a";